import { PHONE_VERIFICATION_EXEMPT_DIRECT_LINK_TYPES } from '@src/domains/direct-links';
import { needsPhoneVerification } from '@src/domains/payments/core/needsPhoneVerification';
import type { PaymentOption } from '@src/domains/payments/types/payment';

type Input = {
  paymentOption?: PaymentOption;
  phoneVerifiedAt?: string | null;
  directLinkType?: string;
};

// Whoever opens a payment, sale or order link was handed it directly, so there is no account phone to
// confirm. Every other flow falls back to the plain rule.
export const needsPhoneVerificationUnlessPaymentLink = ({
  paymentOption,
  phoneVerifiedAt,
  directLinkType,
}: Input): boolean =>
  !PHONE_VERIFICATION_EXEMPT_DIRECT_LINK_TYPES.includes(directLinkType ?? '') &&
  needsPhoneVerification({ paymentOption, phoneVerifiedAt });
